<template>
    <article :class="containerClass">
        <FeaturePageBadge
            v-if="badgeText !== null && badgePosition === 'top'"
            :text="badgeText"
            :variant="badgeVariant"
            :size="badgeSize"
            :uppercase="badgeUppercase"
            :class="badgeClass"
        />

        <h3
            v-if="title !== null"
            :class="titleClass"
        >
            {{ title }}
        </h3>
        <p :class="getDescriptionClass()">{{ description }}</p>

        <FeaturePageBadge
            v-if="badgeText !== null && badgePosition === 'bottom'"
            :text="badgeText"
            :variant="badgeVariant"
            :size="badgeSize"
            :uppercase="badgeUppercase"
            :class="badgeClass"
        />
    </article>
</template>

<script setup lang="ts">
    import FeaturePageBadge from '@/Marketing/LandingPage/Component/FeaturePage/Badge.vue'

    type FeaturePageBadgeVariant =
        'neutral' | 'primary' | 'success' | 'upcoming'
    type FeaturePageBadgeSize = 'xs' | 'sm' | 'md'
    type FeaturePageBadgePosition = 'top' | 'bottom'

    interface FeaturePageInfoCardProps {
        title?: string | null
        description: string
        badgeText?: string | null
        badgeVariant?: FeaturePageBadgeVariant
        badgeSize?: FeaturePageBadgeSize
        badgePosition?: FeaturePageBadgePosition
        badgeUppercase?: boolean
        badgeClass?: string
        containerClass?: string
        titleClass?: string
        descriptionClass?: string
        descriptionWithoutTitleClass?: string
    }

    const props = withDefaults(defineProps<FeaturePageInfoCardProps>(), {
        title: null,
        badgeText: null,
        badgeVariant: 'upcoming',
        badgeSize: 'xs',
        badgePosition: 'top',
        badgeUppercase: true,
        badgeClass: 'mb-2',
        containerClass: 'rounded-xl border border-slate-200 bg-white p-4',
        titleClass: 'text-base font-bold text-slate-900',
        descriptionClass: 'mt-1 text-sm text-slate-600',
        descriptionWithoutTitleClass: 'text-sm text-slate-700',
    })

    function getDescriptionClass(): string {
        return props.title === null
            ? props.descriptionWithoutTitleClass
            : props.descriptionClass
    }
</script>
